export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7354.cbe92fe7.jpg";